"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var PropTypes = require("prop-types");
var _1 = require("../util/_");
var month_1 = require("./month");
var century_1 = require("./century");
var year_1 = require("./year");
var decade_1 = require("./decade");
var CustomPropTypes = require("../util/custom-prop-types");
var CalendarView = /** @class */ (function (_super) {
    __extends(CalendarView, _super);
    function CalendarView() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    CalendarView.prototype.render = function () {
        var _a = this.props, calendarView = _a.calendarView, dayComponent = _a.dayComponent, onChange = _a.onChange;
        var viewProps = _1.omit(this.props, ['calendarView', 'dayComponent', 'decadeFormat', 'tabIndex']);
        switch (calendarView) {
            case 'month': return React.createElement(month_1.Month, __assign({}, viewProps, { onChange: onChange, dayComponent: dayComponent }));
            case 'year': return React.createElement(year_1.Year, __assign({}, viewProps, { onChange: onChange }));
            case 'decade': return React.createElement(decade_1.Decade, __assign({}, viewProps, { onChange: onChange }));
            case 'century': return React.createElement(century_1.Century, __assign({}, viewProps, { onChange: onChange, decadeFormat: this.props.decadeFormat }));
        }
        throw new Error('Unknown calendar view: ' + calendarView);
    };
    CalendarView.propTypes = {
        calendarView: PropTypes.oneOf(['month', 'year', 'decade', 'century']).isRequired,
        culture: PropTypes.string,
        value: PropTypes.instanceOf(Date),
        focused: PropTypes.instanceOf(Date).isRequired,
        min: PropTypes.instanceOf(Date).isRequired,
        max: PropTypes.instanceOf(Date).isRequired,
        today: PropTypes.instanceOf(Date),
        onChange: PropTypes.func.isRequired,
        decadeFormat: PropTypes.any,
        className: PropTypes.string,
        disabled: PropTypes.bool,
        readOnly: PropTypes.bool,
        onAriaActiveDescendant: PropTypes.func,
        dayComponent: CustomPropTypes.elementType,
        tabIndex: PropTypes.number
    };
    return CalendarView;
}(React.Component));
exports.CalendarView = CalendarView;



//////////////////
// WEBPACK FOOTER
// ./node_modules/adp-react-components/lib/calendar/calendar-view.js
// module id = 524
// module chunks = 0 1 2 3 4 5 6